
        <div class="col-sm-12">
            <input type="text" [ngClass]="{'minimum-required': errors!=null && errors?.otherMinimumRequired!=null}" [id]="id" (change)="onChange($event)" [value]="getOtherValues()" class="form-control" placeholder="Others">
            <ng-container *ngIf="errors!=null && errors?.otherMinimumRequired!=null">
                            <span class="error_msg">{{errors?.otherMinimumRequired}}</span>
            </ng-container>
        </div>
        <ng-content></ng-content>
    